<template lang="html">
  <!-- HomeDashboardBackup -->
  <HomeDashboardBackup
    :show_invitation_slot="getProjectInvites.length > 0? true: false"
    >
    <!-- greeting -->
    <template #greeting>
      <h1>
        Welcome back {{ getUser.first_name + ' ' + getUser.last_name}}
      </h1>
    </template>

    <!-- Invitations -->
    <template #invitations>
      <StandardCard
        v-for="invitation in getProjectInvites"
        :key="'invite'+invitation.id"
        :image="invitation.project.image"
        :name="invitation.project.name"
        :cols="12"
        >
        <template #info>
          <div class="UserHome-invitationcard-title">
            <v-icon color="primary">person</v-icon>
            {{invitation.prole}}
            <div class="ml-2 craftsman-workpackages">
              <TWorkPackage
                v-for="wp in invitation.work_packages"
                :key="`wp${wp.id}`"
                :workpackage_count="1"
                :workpackage="wp"
                :color="wp.color"
                >
                <template #workpackage>
                  <StandardBadge
                    :text="wp.count"
                    color="white"
                    content_color="black"
                  />
                </template>
            </TWorkPackage>
          </div>
        </div>
          <v-card-actions>
            <v-btn
              color="green"
              style="width: 40%"
              @click="acceptProjectInvite(invitation)"
              >
              accept
            </v-btn>
            <v-btn
              color="red"
              @click="declineProjectInvite(invitation)"
              >
              decline
            </v-btn>
          </v-card-actions>
        </template>
      </StandardCard>
    </template>
  </HomeDashboardBackup>
</template>

<script>
  import {
    mapGetters, mapActions
  } from 'vuex';

  import { TWorkPackageMixin } from '@/mixins/TWorkPackage.mixin.js'
  import { WorkPackageLargeMixin } from '@/mixins/WorkPackageLarge.mixin.js';

  import HomeDashboardBackup from '@/components/HomeDashboardBackup/HomeDashboardBackup.component.vue'
  import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
  import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
  // import HomeDashboardBackupNews from '@/components/HomeDashboardBackup/HomeDashboardBackupNews.component.vue'
  // import HomeDashboardBackupCommunitySequences from '@/components/HomeDashboardBackup/HomeDashboardBackupCommunitySequences.component.vue'
  // import SequenceHeaderDetails from '@/components/Sequences/SequenceHeaderDetails.component.vue';
  // import Train from '@/components/ProjectTaktPlan/Train.component.vue';
  // import TaktArea from '@/components/ProjectTaktPlan/TaktArea.component.vue';
  // import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue';
  // import Waggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
  // import StandardHover from '@/components/StandardComponents/StandardHover.component.vue';
  // import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
  // import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue';
  // import CommunityOwnerDetails from '@/components/Community/CommunityOwnerDetails.component.vue';

  import store from '@/store/index'

  export default {
    name: 'UserHome',
    components: {
      HomeDashboardBackup,
      StandardCard,
      StandardBadge,
      // HomeDashboardBackupNews,
      // HomeDashboardBackupCommunitySequences,
      // SequenceHeaderDetails,
      // Train,
      // TaktArea,
      // TrainHead,
      // Waggon,
      // StandardHover,
      // WorkPackage,
      // TrainTail,
      // CommunityOwnerDetails
    },
    mixins: [TWorkPackageMixin, WorkPackageLargeMixin],

    data: function() {
      return {
        hashtags: '',
        waggon_large_dialog: false,
        work_packages_large: [],
        work_packages_large_index: 0,
      }
    },

    beforeRouteEnter (to, from, next) {
      store.dispatch('User/requestUserProjectInvites', store.getters['Auth/getUser'].id).then(() => {
        next();
      });
        store.dispatch('Community/requestLatestCommunityEntities').then(res => next(res));
    },

    computed: {
      ...mapGetters('Auth',[
        'getUser',
        'hasPermission',
        'getUserId'
      ]),
      ...mapGetters('User',[
        'getProjectInvites'
      ]),
      ...mapGetters('Community',[
        'getCommunityLatest',
        'isLoading'
      ])
    },

    methods: {
      ...mapActions('ProjectInvitation', [
        'acceptProjectInvite',
        'declineProjectInvite'
      ]),
      ...mapActions('Community', [
        'requestLatestCommunityEntities',
        'likeCommunitySequence',
        'unlikeCommunitySequence',
        'requestCommunitySequencesByHashtags',
        'requestCommunitySequences'
      ]),
    },

  }
</script>

<style lang="css" scoped>

  .UserHome-invitationcard-title {
    display:flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    gap: 3px;
    margin: 5px;
    height: 40px;
  }
  .craftsman-workpackages {
    display: flex;
    overflow-x: auto;
    flex-wrap: nowrap;
    overflow-y: visible;
  }
  .invite-actions {
    float: right;
  }

</style>
